<template>
  <b-row>
    <b-col md="4">
      <label>Negocio Pipedrive</label>
    </b-col>
    <b-col md="8">
      <b-form-input
        ref="input"
        v-model="value"
        placeholder="URL o ID del negocio"
        @focus="editField"
        @blur="asignar"
        :readonly="readonly"
        :disabled="disabled"
      />
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";

export default {
  props: {
    disabled: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(useOfertaFormStore, ["oferta", "ofertaPipedrive"]),
  },
  data() {
    return {
      value: "",
      readonly: false,
    };
  },
  methods: {
    asignar() {
      let value = String(this.value).trim();

      if (value != "" && isNaN(value)) {
        if (value.includes("https://esg-innova.pipedrive.com/deal/")) {
          value = value.split("/").pop();
        } else {
          value = "";
        }
      }

      value = Number(value);

      if (value > 0) {
        this.ofertaPipedrive.dealId = value;
        this.oferta.pipedrive = `https://esg-innova.pipedrive.com/deal/${value}`;
        this.value = this.oferta.pipedrive;
        this.readonly = true;
      } else {
        this.oferta.pipedrive = "";
        this.ofertaPipedrive.dealId = null;
      }
    },
    editField(event) {
      event.target.select();
      this.readonly = false;
    },
  },
  mounted() {
    this.value = this.oferta.pipedrive;
    this.readonly = this.oferta.pipedrive != "";
  },
};
</script>
